// theme.js — ShallowSky Shopify theme
// • Product hover image cycling (works on grid + PDP gallery)
// • Glitch button hover (RGB split + character scramble)
// • Inner Circle persistent bar dismissal
// • Glitch level read from <body class="glitch-...">

(function () {
  // ───── GLITCH LEVEL FROM BODY CLASS ─────────────────────────────────
  const body = document.body;
  const glitchClass = [...body.classList].find((c) => c.startsWith("glitch-"));
  const level = glitchClass ? glitchClass.replace("glitch-", "") : "subtle";
  window.__glitchOff = level === "off";
  window.__glitchDur =
    level === "loud" ? 600 : level === "medium" ? 380 : level === "subtle" ? 220 : 0;

  // ───── PRODUCT HOVER CYCLE ─────────────────────────────────────────
  function attachHoverCycle(card) {
    if (card._hoverCycleBound) return;
    card._hoverCycleBound = true;
    const media = card.classList.contains("prod-media") ? card : card.querySelector(".prod-media");
    if (!media) return;
    const frames = [...media.querySelectorAll(".frame")];
    const dots = [...media.querySelectorAll(".prod-dots span")];
    if (frames.length < 2) return;

    let idx = 0;
    let timer = null;

    const setFrame = (i) => {
      frames.forEach((f, k) => f.classList.toggle("active", k === i));
      dots.forEach((d, k) => d.classList.toggle("active", k === i));
    };

    card.addEventListener("mouseenter", () => {
      timer = setInterval(() => {
        idx = (idx + 1) % frames.length;
        setFrame(idx);
      }, 900);
    });
    card.addEventListener("mouseleave", () => {
      if (timer) clearInterval(timer);
      timer = null;
      idx = 0;
      setFrame(0);
    });
  }

  function attachAllProductCards() {
    document.querySelectorAll(".prod, [data-product-gallery]").forEach((el) => {
      // .prod is the grid card; [data-product-gallery] is the PDP gallery
      const card = el.classList.contains("prod") ? el : el.closest("section, .release-cover, .product-gallery") || el;
      attachHoverCycle(el.classList.contains("prod") ? el : el);
    });
  }

  // ───── GLITCH HOVER ────────────────────────────────────────────────
  const GLYPHS = "▓▒░█▌▐|/\\ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

  function scramble(el, dur) {
    const layer = el.querySelector(".layer");
    if (!layer) return;
    const original = el.dataset.text || layer.textContent;
    if (!el.dataset.text) el.dataset.text = original;

    const start = performance.now();
    const len = original.length;

    const step = (t) => {
      const p = Math.min(1, (t - start) / dur);
      const reveal = Math.floor(p * len);
      let out = "";
      for (let i = 0; i < len; i++) {
        const ch = original[i];
        if (i < reveal || ch === " " || ch === "\n") {
          out += ch;
        } else {
          out += GLYPHS[(Math.random() * GLYPHS.length) | 0];
        }
      }
      layer.textContent = out;
      if (p < 1) {
        el._raf = requestAnimationFrame(step);
      } else {
        layer.textContent = original;
        el.dataset.active = "0";
      }
    };

    cancelAnimationFrame(el._raf);
    el._raf = requestAnimationFrame(step);
  }

  function attachGlitch() {
    document.querySelectorAll(".glitch").forEach((el) => {
      if (el._glitchBound) return;
      el._glitchBound = true;
      const layer = el.querySelector(".layer");
      if (!layer) return;
      if (!el.dataset.text) {
        el.dataset.text = layer.textContent.trim().replace(/\s+/g, " ");
      }
      el.addEventListener("mouseenter", () => {
        if (window.__glitchOff || !window.__glitchDur) return;
        el.dataset.active = "1";
        scramble(el, window.__glitchDur);
      });
      el.addEventListener("mouseleave", () => {
        el.dataset.active = "0";
        const layer = el.querySelector(".layer");
        if (layer) layer.textContent = el.dataset.text;
        cancelAnimationFrame(el._raf);
      });
    });
  }

  // ───── INNER CIRCLE BAR ────────────────────────────────────────────
  function attachIcBar() {
    const bar = document.getElementById("ic-bar");
    const x = document.getElementById("ic-bar-x");
    if (!bar || !x) return;
    if (sessionStorage.getItem("ic-bar-dismissed") === "1") {
      bar.classList.add("hidden");
    }
    x.addEventListener("click", (e) => {
      e.preventDefault();
      bar.classList.add("hidden");
      sessionStorage.setItem("ic-bar-dismissed", "1");
    });
  }

  // ───── MARQUEE SPEED ─────────────────────────────────────────────
  // animation-duration is fixed in CSS but the content length varies,
  // so a flat duration either crawls or loops before finishing. Derive
  // duration from measured content width so pace (px/s) stays constant.
  const MARQUEE_PX_PER_SECOND = 55;
  let marqueeResizeWidth = window.innerWidth;

  function setMarqueeSpeed() {
    document.querySelectorAll(".marquee").forEach((el) => {
      const loopWidth = el.scrollWidth / 2; // one of the two duplicated copies
      if (!loopWidth) return;
      const duration = (loopWidth / MARQUEE_PX_PER_SECOND) + "s";
      // Reassigning animation-duration while the animation is running
      // restarts it from 0% in mobile WebKit, so only touch the style
      // when the value actually needs to change.
      if (el.style.animationDuration !== duration) {
        el.style.animationDuration = duration;
      }
    });
  }

  function handleMarqueeResize() {
    // Mobile browsers fire "resize" when the address bar collapses/expands
    // during scroll, even though the viewport width hasn't changed. Ignore
    // those so the marquee animation doesn't keep getting restarted.
    if (window.innerWidth === marqueeResizeWidth) return;
    marqueeResizeWidth = window.innerWidth;
    setMarqueeSpeed();
  }

  // ───── MOBILE NAV ────────────────────────────────────────────────
  function attachMobileNav() {
    const burger = document.querySelector('.nav-burger');
    const mobileNav = document.getElementById('mobile-nav');
    if (!burger || !mobileNav) return;
    burger.addEventListener('click', () => {
      const open = burger.getAttribute('aria-expanded') === 'true';
      burger.setAttribute('aria-expanded', String(!open));
      mobileNav.classList.toggle('open', !open);
      mobileNav.setAttribute('aria-hidden', String(open));
    });
    mobileNav.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        burger.setAttribute('aria-expanded', 'false');
        mobileNav.classList.remove('open');
        mobileNav.setAttribute('aria-hidden', 'true');
      });
    });
  }

  // ───── INIT ────────────────────────────────────────────────────────
  function init() {
    attachAllProductCards();
    attachGlitch();
    attachIcBar();
    attachMobileNav();
    setMarqueeSpeed();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Re-bind after Shopify Section Rendering API swaps
  document.addEventListener("shopify:section:load", init);
  window.addEventListener("resize", handleMarqueeResize);
})();
